import { Table } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { DataTable } from '@/components/ui-shared/Tables/DataTable'
import { WorkspaceApiKey } from '@/types/workspace'
import { ApiKeyListItem } from './ApiKeyListItem'

type ApiKeysListProps = {
  apiKeys: WorkspaceApiKey[]
  isLoading?: boolean
  hasError?: boolean
  onReload?: () => void
}

export const ApiKeysList = ({
  apiKeys,
  isLoading,
  hasError,
  onReload
}: ApiKeysListProps) => {
  return (
    <DataTable
      hasItems={apiKeys.length > 0}
      isLoading={isLoading}
      hasError={hasError}
      onReload={onReload}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={40}>&nbsp;</Table.Th>

          <Table.Th>
            <FormattedMessage id="workspace.apiKeys.columns.name" />
          </Table.Th>

          <Table.Th>
            <FormattedMessage id="workspace.apiKeys.columns.scope" />
          </Table.Th>

          <Table.Th>
            <FormattedMessage id="workspace.apiKeys.columns.applications" />
          </Table.Th>

          <Table.Th>
            <FormattedMessage id="workspace.apiKeys.columns.createdBy" />
          </Table.Th>

          <Table.Th>
            <FormattedMessage id="workspace.apiKeys.columns.createdAt" />
          </Table.Th>

          <Table.Th w={80}>&nbsp;</Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {apiKeys.map((apiKey) => (
          <ApiKeyListItem key={apiKey.id} apiKey={apiKey} />
        ))}
      </Table.Tbody>
    </DataTable>
  )
}
